import React from "react";

import moment from "moment";
import { FormattedMessage } from "react-intl";
import { Button } from "../../../button/Button";
import { ShieldLogo } from "../../../graphic/ShieldLogo/ShieldLogo";
import Col from "../../../grid/Col";
import Row from "../../../grid/Row";
import { PageMessage } from "../../../page/PageMessage";
import { Text } from "../../../typography/Text";

const msgKey = "accountActivationMessage";

export const Trialing = ({ account, accountName, chooseSubscriptionLink }) => {
    const activeDays = parseInt(moment(account.activeDate).diff(moment(), "days"), 10);
    return activeDays < 1 ? (
        <PageMessage title={<FormattedMessage id={`${msgKey}.trialExpiredTitle`} />} figure={<ShieldLogo size={100} />}>
            <Row>
                <Col span={24}>
                    <Text size="xlarge" weight="semiBold" color="error">
                        <FormattedMessage id={`${msgKey}.zeroDaysLeft`} />
                    </Text>
                </Col>
                <Col span={24}>
                    <Text block size="medium" color="base80">
                        <FormattedMessage
                            id={`${msgKey}.trialExpiredMessage`}
                            values={{ name: accountName, strong: (msg) => <strong>{msg}</strong> }}
                        />
                    </Text>
                </Col>
                <Col span={24}>
                    <Button link={chooseSubscriptionLink} color="success" icon="ticket" size="big">
                        <FormattedMessage id={`${msgKey}.chooseSubscription`} />
                    </Button>
                </Col>
            </Row>
        </PageMessage>
    ) : (
        <PageMessage title={<FormattedMessage id={`${msgKey}.trialActiveTitle`} />} figure={<ShieldLogo size={100} />}>
            <Row gutter={["regular", "regular"]}>
                <Col span={24}>
                    <Text size="xlarge" weight="semiBold" color="success">
                        <FormattedMessage id={`${msgKey}.trialDaysLeft`} values={{ days: activeDays }} />
                    </Text>
                </Col>
                <Col span={24}>
                    <Text block size="medium" color="base80">
                        <FormattedMessage
                            id={`${msgKey}.trialActiveMessage`}
                            values={{
                                name: accountName,
                                days: activeDays,
                                strong: (msg) => <strong>{msg}</strong>
                            }}
                        />
                    </Text>
                </Col>
                <Col span={24}>
                    <Button link={chooseSubscriptionLink} color="success" icon="ticket" size="big">
                        <FormattedMessage id={`${msgKey}.chooseSubscription`} />
                    </Button>
                </Col>
            </Row>
        </PageMessage>
    );
};
